import { render } from "./GetPosts.vue?vue&type=template&id=5743c490"
import script from "./GetPosts.vue?vue&type=script&lang=js"
export * from "./GetPosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__